import { AppConfig } from '../../app.config';
import { ApiResponse } from './../_base/apiResponse.model';
import { EndpointModel } from './endpoint.model';

export class LoginResponseModel extends ApiResponse {
  token: string = null;
  incomplete: boolean = false;
  questionnaireId: string;
  userId: number;
  displayLanguage: string = AppConfig.defaultLocale;
  hasSeenLatestPolicy: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/models/auth/loginResponse.model.ts